import { GroupSecurity } from '@quromedical/fhir-common';
import type { VideoConsultCreateRoomResponse } from '@quromedical/models';
import type { PatientRouteParams } from 'app/routes';
import { WithGroup } from 'core/auth';
import { CreateMeetingCard } from 'core/video-consult';
import { Section, SkeletonProvider } from 'design-system';
import { useLocalSearchParams } from 'expo-router';
import { logger } from 'helpers';
import { VideoConsultApi } from 'integration/aggregate';
import { useMeeting } from 'providers/video';
import type React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { ScrollView } from 'react-native-gesture-handler';

const videoApi = new VideoConsultApi();

type State = 'initial' | 'loading' | 'error' | VideoConsultCreateRoomResponse;

export const PatientVideoConsultTab: React.FC = () => {
  const { patientId } = useLocalSearchParams<PatientRouteParams>();
  const meeting = useMeeting();

  const [state, setState] = useState<State>('initial');

  const room = typeof state !== 'string' ? state : undefined;

  useEffect(() => {
    const exec = async () => {
      setState('loading');
      try {
        const result = await videoApi.createRoom(patientId);
        setState(result);
      } catch (err) {
        setState('error');
        logger.error(err);
      }
    };
    exec().catch(logger.error);
  }, [patientId]);

  const handleJoinWaitingRoom = useCallback(() => {
    if (!room) {
      return;
    }

    meeting.joinWaitingRoom(room.token);
  }, [room, meeting]);

  return (
    <SkeletonProvider loading={!room}>
      <ScrollView>
        <WithGroup groups={[GroupSecurity.VideoConsultCreate]}>
          <Section>
            <CreateMeetingCard
              patientId={patientId}
              room={room}
              handleJoinWaitingRoom={handleJoinWaitingRoom}
            />
          </Section>
        </WithGroup>
      </ScrollView>
    </SkeletonProvider>
  );
};
